(function () {
  'use strict';

  const header = document.getElementById('header');
  const hamburger = document.getElementById('hamburger');
  const navMenu = document.getElementById('navMenu');

  // Header scroll
  if (header) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(() => { header.classList.toggle('is-scrolled', window.scrollY > 10); ticking = false; }); ticking = true; }
    }, { passive: true });
  }

  // Hamburger
  if (hamburger && navMenu) {
    hamburger.addEventListener('click', () => {
      const open = document.body.classList.toggle('mobile-menu-open');
      hamburger.setAttribute('aria-expanded', open);
    });
    navMenu.querySelectorAll('a').forEach(l => l.addEventListener('click', () => { document.body.classList.remove('mobile-menu-open'); hamburger.setAttribute('aria-expanded', 'false'); }));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && document.body.classList.contains('mobile-menu-open')) { document.body.classList.remove('mobile-menu-open'); hamburger.setAttribute('aria-expanded', 'false'); hamburger.focus(); } });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      // Se um handler mais específico já tratou este link (ex.: a âncora de compra
      // do offer-stack, que mira os kits em vez do topo da seção), não sobrescreve.
      // Sem isto, os dois disparam e o último a rodar ganha — que é este, o genérico.
      if (e.defaultPrevented) return;
      e.preventDefault();
      const t = document.querySelector(href);
      if (t) {
        const headerH = header ? header.offsetHeight : 0;
        window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - headerH - 16, behavior: 'smooth' });
      }
    });
  });

  // Shopify AJAX Cart
  function updateCartCount(count) {
    const cartCounts = document.querySelectorAll('.header__cart__count');
    cartCounts.forEach(el => {
      el.textContent = count;
      el.classList.toggle('is-visible', count > 0);
    });
  }

  // Sync cart count on every page load (handles AMP drawer changes from other pages)
  fetch('/cart.js').then(r => r.json()).then(cart => updateCartCount(cart.item_count)).catch(() => {});

  // Listen for cart updates from other sources (AMP Slide Cart, theme add-to-cart)
  document.addEventListener('cart:updated', e => { if (e.detail) updateCartCount(e.detail.item_count); });
  document.addEventListener('cart:refresh', () => {
    fetch('/cart.js').then(r => r.json()).then(cart => updateCartCount(cart.item_count)).catch(() => {});
  });

  // Monkey-patch fetch to detect cart mutations from third-party apps (AMP, etc)
  const _fetch = window.fetch;
  window.fetch = function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    const isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    const p = _fetch.apply(this, args);
    if (isCartMutation) {
      p.then(() => {
        fetch('/cart.js').then(r => r.json()).then(cart => updateCartCount(cart.item_count)).catch(() => {});
      }).catch(() => {});
    }
    return p;
  };

  // Add to cart via AJAX
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      if (!btn || btn.classList.contains('is-loading')) return;

      btn.classList.add('is-loading');
      const origHTML = btn.innerHTML;
      const btnText = btn.querySelector('.btn__text');
      if (btnText) btnText.textContent = 'ADICIONANDO...';

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(r => r.json())
      .then(() => {
        return fetch('/cart.js').then(r => r.json());
      })
      .then(cart => {
        updateCartCount(cart.item_count);
        btn.classList.remove('is-loading');
        if (btnText) btnText.textContent = 'ADICIONADO ✓';
        btn.style.background = '#2D8653';
        setTimeout(() => {
          btn.innerHTML = origHTML;
          btn.style.background = '';
        }, 1800);

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(err => {
        console.error('Cart error:', err);
        btn.classList.remove('is-loading');
        btn.innerHTML = origHTML;
      });
    });
  });

  // CTA Final buttons (redirect to product buy section or product page)
  document.querySelectorAll('.btn--cta-final').forEach(btn => {
    btn.addEventListener('click', function(e) {
      // If it's a link, let it work naturally
      if (this.tagName === 'A') return;
      e.preventDefault();
      const buySection = document.getElementById('comprar');
      if (buySection) {
        const headerH = header ? header.offsetHeight : 0;
        window.scrollTo({ top: buySection.getBoundingClientRect().top + window.scrollY - headerH - 16, behavior: 'smooth' });
      }
    });
  });

  // FAQ accordion
  document.querySelectorAll('[data-faq]').forEach(item => {
    const btn = item.querySelector('.faq__q');
    const answer = item.querySelector('.faq__a');
    if (!btn || !answer) return;
    const id = 'faq-' + Math.random().toString(36).slice(2, 8);
    answer.id = id;
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id);
    btn.addEventListener('click', () => {
      const was = item.classList.contains('is-open');
      document.querySelectorAll('[data-faq]').forEach(i => { i.classList.remove('is-open'); i.querySelector('.faq__q').setAttribute('aria-expanded', 'false'); });
      if (!was) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });

  // Scroll reveal
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduced) {
    const obs = new IntersectionObserver(entries => { entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); } }); }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('[data-aos]').forEach(el => obs.observe(el));
  } else {
    document.querySelectorAll('[data-aos]').forEach(el => { el.style.opacity = '1'; el.style.transform = 'none'; });
  }

  // Pause decorative loop animations (urgency pulse, button shimmer) while off-screen
  if (!reduced) {
    const animTargets = document.querySelectorAll('.urgency-dot, .btn--primary, .btn--cta-final');
    if (animTargets.length) {
      const animObserver = new IntersectionObserver(entries => {
        entries.forEach(e => e.target.classList.toggle('anim-paused', !e.isIntersecting));
      }, { threshold: 0 });
      animTargets.forEach(el => animObserver.observe(el));
    }
  }

  // Floating CTA desktop + WhatsApp (sticky CTA visibility is handled by sticky-buy-bar.liquid)
  const floatCta = document.getElementById('floatCta');
  const whatsappBtn = document.getElementById('whatsappBtn');
  const heroSection = document.querySelector('.hero');

  if (heroSection) {
    const floatObserver = new IntersectionObserver(([e]) => {
      const gone = !e.isIntersecting;
      if (floatCta) floatCta.classList.toggle('is-visible', gone);
      if (whatsappBtn) whatsappBtn.classList.toggle('is-visible', gone);
    }, { threshold: 0 });
    floatObserver.observe(heroSection);
  } else {
    // On non-homepage, show sticky elements after scrolling a bit
    let stickyTicking = false;
    window.addEventListener('scroll', () => {
      if (!stickyTicking) {
        requestAnimationFrame(() => {
          const scrolled = window.scrollY > 300;
          if (floatCta) floatCta.classList.toggle('is-visible', scrolled);
          if (whatsappBtn) whatsappBtn.classList.toggle('is-visible', scrolled);
          stickyTicking = false;
        });
        stickyTicking = true;
      }
    }, { passive: true });
  }

  // Countdown timer
  const countH = document.getElementById('countH');
  const countM = document.getElementById('countM');
  const countS = document.getElementById('countS');
  if (countH) {
    let rem = 2 * 3600 + 47 * 60 + 33;
    function tick() {
      if (rem <= 0) rem = 2 * 3600 + 59 * 60 + 59;
      countH.textContent = String(Math.floor(rem / 3600)).padStart(2, '0');
      countM.textContent = String(Math.floor((rem % 3600) / 60)).padStart(2, '0');
      countS.textContent = String(rem % 60).padStart(2, '0');
      rem--;
    }
    tick();
    let countTimer = setInterval(tick, 1000);
    const countWrap = countH.closest('.product__countdown');
    if (countWrap) {
      new IntersectionObserver(([e]) => {
        if (e.isIntersecting) {
          if (!countTimer) countTimer = setInterval(tick, 1000);
        } else if (countTimer) {
          clearInterval(countTimer); countTimer = null;
        }
      }, { threshold: 0 }).observe(countWrap);
    }
  }

  // Viewer count
  const viewerEl = document.getElementById('viewerCount');
  if (viewerEl) {
    let v = parseInt(viewerEl.textContent) || 47;
    setInterval(() => { v += Math.floor(Math.random() * 5) - 2; v = Math.max(31, Math.min(68, v)); viewerEl.textContent = v; }, 4000);
  }

  // Stock count
  const stockEl = document.getElementById('stockCount');
  const stockBar = document.getElementById('stockBar');
  if (stockEl) {
    let s = 23;
    setInterval(() => { if (Math.random() < 0.3 && s > 3) { s--; stockEl.textContent = s + ' kits'; if (stockBar) stockBar.style.width = Math.max(6, (s / 100) * 100) + '%'; } }, 15000);
  }

  // Quantity selector
  const qtyOptions = document.querySelectorAll('.qty-option');
  const addToCartBtn = document.getElementById('addToCart');
  qtyOptions.forEach(opt => {
    opt.addEventListener('click', () => {
      qtyOptions.forEach(o => o.classList.remove('is-active'));
      opt.classList.add('is-active');
      const qty = opt.dataset.qty;
      const price = opt.dataset.price;
      const label = opt.dataset.label;
      // Update hidden quantity input
      const qtyInput = opt.closest('form')?.querySelector('input[name="quantity"]');
      if (qtyInput) qtyInput.value = qty;
      if (addToCartBtn) {
        const textEl = addToCartBtn.querySelector('.btn__text');
        if (textEl) textEl.textContent = qty === '1' ? 'COMPRAR AGORA — R$' + price : 'COMPRAR ' + qty + ' KITS — ' + label;
      }
    });
  });

  // Toast (social proof)
  const toast = document.getElementById('toast');
  const toastName = document.getElementById('toastName');
  const toastTime = document.getElementById('toastTime');
  if (toast && toastName && toastTime) {
    const nomes = ['Ana de São Paulo','Juliana de Curitiba','Mariana do Rio','Beatriz de BH','Carolina de Brasília','Isabela de Recife','Larissa de Fortaleza','Gabriela de Porto Alegre'];
    const tempos = ['agora','há 2 min','há 5 min','há 8 min'];
    let ti = 0;
    function showToast() {
      if (reduced) return;
      toastName.textContent = nomes[ti % nomes.length];
      toastTime.textContent = tempos[Math.floor(Math.random() * tempos.length)];
      toast.classList.add('is-visible');
      setTimeout(() => toast.classList.remove('is-visible'), 4000);
      ti++;
    }
    setTimeout(() => { showToast(); setInterval(showToast, 45000); }, 15000);
  }

  // Ticker duplicate for seamless scroll
  const ticker = document.querySelector('.announcement__ticker');
  if (ticker && !reduced) ticker.innerHTML += ticker.innerHTML;

  // Active nav on scroll
  const sections = document.querySelectorAll('section[id]');
  const navLinks = document.querySelectorAll('.header__nav .navlink');
  if (navLinks.length > 0 && sections.length > 0) {
    sections.forEach(s => new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { navLinks.forEach(l => l.classList.toggle('navlink--active', l.getAttribute('href') === '#' + e.target.id)); } });
    }, { threshold: 0.3, rootMargin: '-20% 0px -60% 0px' }).observe(s));
  }

})();
